import { connect } from "react-redux";
import * as Redux from "redux";
import App from "./App";
import { withRouter } from "react-router-dom";

const mapStateToProps = (state: any, props: any): any => {
  return {
    user: state.user
  };
};

export default withRouter(connect(mapStateToProps, {})(App));



// WEBPACK FOOTER //
// ./client/AppContainer.tsx